// extracted by mini-css-extract-plugin
export default {"photoNews":"index_photoNews_CLHeV clearfix"};